import { LabelingObjectData, BoxObject, EllipseObject, PolygonObject } from '@/stores/slices/Labeling/types'

export const isBox = (data?: LabelingObjectData): data is BoxObject => data?.t === 'box'

export const isEllipse = (data?: LabelingObjectData): data is EllipseObject => data?.t === 'ellipse'

export const isPolygon = (data?: LabelingObjectData): data is PolygonObject & { isPathEditable: true } => data?.t === 'polygon' && data.isPathEditable

export const isBrush = (data?: LabelingObjectData): data is PolygonObject & { isPathEditable: false } => data?.t === 'polygon' && !data.isPathEditable
